import { render } from "./FreetargetUpdate.vue?vue&type=template&id=eabf3206"
import script from "./FreetargetUpdate.vue?vue&type=script&lang=js"
export * from "./FreetargetUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__